import ContrastDict from './ContastDict';
import Contrast from './Contrast';

export default class ContrastHierarchy {
    constructor() {
        this.contrastDict = new ContrastDict([
            new Contrast(
                'collarFabric',
                'collar',
                ['Parent', 'InternalStand', 'ExternalStand'],
                'collarFabric'
            ),
            new Contrast(
                'collarStandFabric',
                'collar',
                ['InternalStand'],
                'collarStandFabric'
            ),
            new Contrast(
                'cuffFabric',
                'cuff',
                ['Internal', 'External'],
                'cuffFabric'
            ),
            new Contrast(
                'cuffTurnFabric',
                'cuff',
                ['Internal'],
                'cuffTurnFabric'
            ),
            new Contrast(
                'fasteningButtonsFabric',
                'cuff',
                [],
                'fasteningButtonsFabric'
            ),
        ])
    }

    getDict() {
        return this.contrastDict.toDict();
    }
}